module.exports = __webpack_public_path__ + "img/ynfw@2x.82a94b8f.png";